class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.template-search');
  if (!root) return;

  var tabs = root.querySelectorAll('.template-search__tab');
  if (!tabs.length) return;

  var panels = root.querySelectorAll('.template-search__tab-panel');
  var summary = document.getElementById('SearchResultsSummary');
  var defaultTab = root.querySelector('.template-search__tab.template-search__tab--active');
  var relatedProductsSection = document.querySelector('.related-products')?.closest('.shopify-section, section, .section');
  var hasHydratedPagesTab = false;

  function getActiveTabType(type) {
    var normalized = (type || '').toLowerCase();
    if (normalized.includes('product')) {
      return 'product';
    }
    if (normalized.includes('page') || normalized.includes('article')) {
      return 'pages';
    }
    return 'product';
  }

  function updateSummary(type) {
    if (!summary) return;
    var summaryType = getActiveTabType(type);
    var resultsCount =
      summaryType === 'pages'
        ? Number(summary.dataset.resultsCountPages || 0)
        : Number(summary.dataset.resultsCountProducts || 0);
    var activeLabel = summaryType === 'pages' ? summary.dataset.resultsLabelPages : summary.dataset.resultsLabelProducts;
    var resultsText = resultsCount + ' ' + activeLabel;

    document.querySelectorAll('#ProductCountDesktop').forEach(function (node) {
      node.textContent = resultsText;
    });

    document.querySelectorAll('.mobile-facets__count').forEach(function (node) {
      node.textContent = resultsText;
    });
  }

  function updateLoadMoreCounter(type) {
    var activeTabType = getActiveTabType(type);
    var activePanelId = activeTabType === 'product' ? 'product-results' : 'page-results';
    var activePanel = document.getElementById(activePanelId);
    var loadMoreContainer = document.querySelector('[data-search-results]');
    var loadMoreButton = document.getElementById('load-more-button');
    var countDisplay = document.getElementById('js-results-shown');
    var totalDisplay = document.getElementById('js-results-total');
    var typeLabelDisplay = document.getElementById('js-results-type-label');
    var shownCount = activePanel ? activePanel.querySelectorAll('.grid__item').length : 0;
    var totalCount = 0;

    if (countDisplay) {
      countDisplay.textContent = shownCount;
    }

    if (totalDisplay && loadMoreContainer) {
      totalCount = Number(
        activeTabType === 'pages'
          ? loadMoreContainer.dataset.resultsTotalPages || '0'
          : loadMoreContainer.dataset.resultsTotalProducts || '0'
      );
      if (shownCount > totalCount) {
        totalCount = shownCount;
      }
      totalDisplay.textContent = String(totalCount);
    }

    if (typeLabelDisplay) {
      var activeLabel =
        activeTabType === 'pages'
          ? loadMoreContainer?.dataset.resultsLabelPages || summary?.dataset.resultsLabelPages
          : loadMoreContainer?.dataset.resultsLabelProducts || summary?.dataset.resultsLabelProducts;
      typeLabelDisplay.textContent = String(activeLabel || '');
    }

    if (loadMoreButton && loadMoreContainer) {
      var nextUrl =
        activeTabType === 'pages' ? loadMoreContainer.dataset.nextUrlPages : loadMoreContainer.dataset.nextUrlProducts;
      var shouldShowButton = shownCount < totalCount;
      if (nextUrl) {
        loadMoreButton.setAttribute('data-url', nextUrl);
      }
      loadMoreButton.classList.toggle('hidden', !shouldShowButton);
    }
  }

  function updateRelatedProductsVisibility(type) {
    if (!relatedProductsSection || !summary) return;
    if (root.dataset.searchPerformed !== 'true') {
      relatedProductsSection.hidden = true;
      return;
    }

    var summaryType = getActiveTabType(type);
    var resultsCount =
      summaryType === 'pages'
        ? Number(summary.dataset.resultsCountPages || 0)
        : Number(summary.dataset.resultsCountProducts || 0);

    relatedProductsSection.hidden = resultsCount > 0;
  }

  function hydratePagesTabIfNeeded() {
    if (hasHydratedPagesTab) return;

    var pagesPanel = document.getElementById('page-results');
    if (!pagesPanel) return;

    var pagesGrid = pagesPanel.querySelector('.grid');
    if (!pagesGrid) return;

    var totalPages = Number(summary?.dataset.resultsCountPages || 0);
    var shownPages = pagesPanel.querySelectorAll('.grid__item').length;

    if (shownPages > 0 || totalPages === 0) {
      hasHydratedPagesTab = true;
      return;
    }

    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', '1');
    currentUrl.searchParams.set('type', 'article,page');
    currentUrl.searchParams.set('section_id', 'main-search');

    fetch(currentUrl.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var fetchedItems = html.querySelectorAll('#page-results .grid__item');

        if (fetchedItems.length > 0) {
          pagesGrid.innerHTML = '';
          fetchedItems.forEach(function (item) {
            pagesGrid.appendChild(item);
          });
        }

        var emptyMessage = pagesPanel.querySelector('.template-search__empty-message');
        if (emptyMessage) {
          emptyMessage.classList.toggle('hidden', fetchedItems.length > 0);
        }

        var loadMoreContainer = document.querySelector('[data-search-results]');
        if (loadMoreContainer) {
          var fetchedNextUrl = html.querySelector('[data-search-results]')?.dataset.nextUrlPages;
          var fallbackNextUrl = html.querySelector('#load-more-button')?.getAttribute('data-url');
          loadMoreContainer.dataset.nextUrlPages = fetchedNextUrl || fallbackNextUrl || '';
        }
      })
      .catch(function () {
        return null;
      })
      .finally(function () {
        hasHydratedPagesTab = true;
        updateLoadMoreCounter('article,page');
      });
  }

  function setActiveTab(type) {
    var activeTabType = getActiveTabType(type);

    tabs.forEach(function (tab) {
      var tabType = tab.dataset.type;
      var isActive =
        (activeTabType === 'product' && tabType === 'product') ||
        (activeTabType === 'pages' && tabType === 'article,page');
      tab.classList.toggle('template-search__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      var targetId = panel.id;
      var shouldShow =
        (activeTabType === 'product' && targetId === 'product-results') ||
        (activeTabType === 'pages' && targetId === 'page-results');
      panel.classList.toggle('template-search__tab-panel--active', shouldShow);
    });

    if (activeTabType === 'pages') {
      hydratePagesTabIfNeeded();
    }

    updateSummary(type);
    updateLoadMoreCounter(type);
    updateRelatedProductsVisibility(type);
  }

  function updateTypeTotals(productTotal, pagesTotal) {
    if (summary) {
      summary.dataset.resultsCountProducts = String(productTotal);
      summary.dataset.resultsCountPages = String(pagesTotal);
    }

    var loadMoreContainer = document.querySelector('[data-search-results]');
    if (loadMoreContainer) {
      loadMoreContainer.dataset.resultsTotalProducts = String(productTotal);
      loadMoreContainer.dataset.resultsTotalPages = String(pagesTotal);
    }

    var activeTab = document.querySelector('.template-search__tab.template-search__tab--active');
    var activeType = activeTab ? activeTab.dataset.type : 'product';

    if (activeType === 'product' && Number(productTotal) === 0 && Number(pagesTotal) > 0) {
      setActiveTab('article,page');
      return;
    }

    updateSummary(activeType);
    updateLoadMoreCounter(activeType);
    updateRelatedProductsVisibility(activeType);
  }

  function fetchTypeTotal(type) {
    var currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('page', '1');
    currentUrl.searchParams.set('type', type);
    currentUrl.searchParams.set('section_id', 'main-search');

    return fetch(currentUrl.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var totalNode = html.querySelector('.template-search[data-total-results]');
        return Number(totalNode?.dataset.totalResults || 0);
      })
      .catch(function () {
        return 0;
      });
  }

  if (window.location.search.includes('q=')) {
    Promise.all([fetchTypeTotal('product'), fetchTypeTotal('article,page')]).then(function (totals) {
      updateTypeTotals(totals[0], totals[1]);
    });
  }

  var urlSearchParams = new URLSearchParams(window.location.search);
  var urlTab = urlSearchParams.get('search_tab');
  var initialType = defaultTab ? defaultTab.dataset.type : 'product';
  if (urlTab === 'pages') {
    initialType = 'article,page';
  } else if (urlTab === 'products') {
    initialType = 'product';
  }
  setActiveTab(initialType);

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabType = tab.dataset.type;
      if (!tabType) return;
      setActiveTab(tabType);
    });
  });

  document.addEventListener('search:load-more-updated', function () {
    var activeTab = document.querySelector('.template-search__tab.template-search__tab--active');
    var activeType = activeTab ? activeTab.dataset.type : 'product';
    updateLoadMoreCounter(activeType);
  });
});
